import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectApplicationsDeleteData = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsDelete.data,
);
export const selectApplicationsDeleteLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsDelete.loading,
);
export const selectApplicationsDeleteError = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.applicationsDelete.error,
);
